import React, { Component } from 'react'
import PropTypes from 'prop-types'
import compose from '@shopify/react-compose'
import { withTranslation } from 'react-i18next'

import RanActivateView from './ran-activate-view'
import Confirmation from './confirmation'

import { AppLoader } from '@portal/kit/pkg/components'
import { activateRanRoom } from '@portal/kit/pkg/services'

class RanActivateContainer extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isActivating: props.autoStart,
      globalError: null,
      room: null,
    }
  }

  activateRan = () => {
    this.setState({ isActivating: true })

    activateRanRoom()
      .then(response => this.setState({ room: response.data, isActivating: false }))
      .catch(e => this.setState({ globalError: e.response.data.error?.message || this.props.t('form.error'), isActivating: false }))
  }

  componentDidMount() {
    if (this.props.autoStart) this.activateRan()
  }

  render() {
    if (this.state.isActivating) return <AppLoader />
    if (this.state.room) return (
      <Confirmation
        room={this.state.room}
        viewRanList={this.props.refreshRooms}
      />
    )

    return (
      <RanActivateView
        activateRan={this.activateRan}
        error={this.state.globalError}
      />
    )
  }
}

RanActivateContainer.propTypes = {
  autoStart: PropTypes.bool,
  refreshRooms: PropTypes.func.isRequired,
}

RanActivateContainer.defaultProps = {
  autoStart: false,
}

export default compose(
  withTranslation(),
)(RanActivateContainer)
